// removed by extract-text-webpack-plugin
module.exports = {"article":"src-templates----location-module---article---2ZwUy","articleTitle":"src-templates----location-module---articleTitle---3hfGM","articleContent":"src-templates----location-module---articleContent---1v2O6"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/location.module.scss
// module id = 334
// module chunks = 16192702802281